/**
 * Formata em BRL no padrão do pacote: "R$ 1.234,56" e "- R$ 58,90" (sinal separado por espaço).
 * O `LisboonMoneyAmount` de `@lisboon/shared` usa Intl currency ("-R$" com espaço fixo), que muda o texto
 * em relação ao pacote; por isso o formato do pacote fica aqui.
 */
export function formatBRL(value: number): string {
  const abs = Math.abs(value);
  const n = abs.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${value < 0 && abs !== 0 ? '- ' : ''}R$ ${n}`;
}

export type AmountProps = {
  value: number;
  /** Entradas ganham "+ " e verde; saídas mostram "- ". Desligue para valores neutros (faturas, totais). */
  signed?: boolean;
  /** `auto` = verde para positivo quando `signed`; `neutral` = sempre navy. */
  tone?: 'auto' | 'neutral';
  /** `lg` é o valor grande do painel de detalhes (classe `.amount` do pacote). */
  size?: 'md' | 'lg';
  /** Peso 600 como nas tabelas (padrão) ou herdado. */
  bold?: boolean;
};

/** Valor monetário com sinal e cor, como nas tabelas de transações e Finanças. */
export function Amount({ value, signed = true, tone = 'auto', size = 'md', bold = true }: AmountProps) {
  const positive = signed && value > 0;
  const text = positive ? `+ ${formatBRL(value)}` : formatBRL(value);
  if (size === 'lg') return <div className="amount">{text}</div>;
  const style = {
    ...(bold ? { fontWeight: 600 } : {}),
    ...(positive && tone === 'auto' ? { color: 'var(--green)' } : {}),
  };
  return <span style={style}>{text}</span>;
}
